module.exports = __webpack_public_path__ + "static/media/night1.c087ec38.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/night1.jpeg
// module id = 24
// module chunks = 0